<template>
  <div>
    <div class="contentBody__title">
      <span class="text">仮登録完了</span>
    </div>
    <section class="contentBody__section">
      <div class="u-mg-t-1 image-mail">
        <img width="96" height="82" src="/static/img/check-email.svg">
      </div>
      <p class="mail_param u-tx-center u-tx-size-15 u-tx-black u-mg-t-2">{{ email }}</p>

      <div class="simple_box">
        <p class="u-tx-sub u-tx-size-13 u-tx-line-height-20">上記のメールアドレス宛に、ユーザー登録確認のメールを送信しました。メールに記載された URL にアクセスして本登録を完了させてください。</p>
      </div>

      <div v-if="confirmReturnPath">
        <p class="u-tx-size-14 u-tx-line-height-20 u-tx-black u-mg-t-2 u-mg-b-2">本登録をせずに購入する場合は、プロフィール入力へ進んでください。</p>
        <form method="post" :action="confirmReturnPath">
          <input type="hidden" name="_token" :value="csrfToken">
          <input type="hidden" :value="accessToken" name="access_token">
          <input type="hidden" v-if="cpno" name="cpno" :value="cpno">
          <button type="submit"
          class="btn"
          data-block="true"
          data-color="brand"
          >プロフィール入力へ</button>
        </form>
      </div>

      <hr class="contentSeparatorSection u-mg-b-2 u-mg-t-4">

      <p class="u-tx-sub u-tx-size-12 u-tx-line-height-20">
        【登録確認メールが届かない場合】
        <br>・迷惑メールフォルダや、ゴミ箱に振り分けられていないかご確認ください。
        <br>・携帯メールアドレスをお使いの場合、ドメイン設定の影響で登録メールが届かない場合があります。「uranai.tv」を受信設定して、<a class="u-tx-brand-2" href="/user/input">メールアドレスの再入力</a>をお願いします。
      </p>

      <a
      v-if="!confirmReturnPath"
      href="/" class="btn u-mg-t-4"
      data-block="true"
      data-stroke="true"
      data-color="brand"
      >AGARUTV TOPへ</a>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
export default{
  name: 'provisional-regist',
  props: {
    email: { type: String, default: '' },
    confirmReturnPath: { type: String, default: '' },
    orderId: { type: String, default: '' },
    productId: { type: String, default: '' },
    productPrice: { type: String, default: '' },
    productName: { type: String, default: '' },
    productQuantity: { type: String, default: '' }

  },
  computed: {
    ...mapState({
      accessToken: state => state.auth.accessToken,
      userAccount: state => state.account.profile
    }),
    ...mapGetters(['isLoggedIn'])
  },
  data() {
    return {
      csrfToken: window.Laravel.csrfToken,
      cpno: window.Laravel.cpno,
    }
  },
  mounted(){
    if(this.productId){
      this.setMonetrack()
    }
  },
  methods: {
    setMonetrack(){
      var productInfo = []
      const productObj = {
        product_id: this.productId,
        product_price: this.productPrice,
        product_quantity: this.productQuantity,
        product_name: this.productName
      }
      productInfo.push(productObj)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ProvisionalRegist.vue